import { cn } from '@/lib/utils';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
}

export function Button({
  children,
  className,
  variant = 'primary',
  size = 'md',
  ...props
}: ButtonProps) {
  const baseStyles = 'font-semibold rounded-lg transition-all duration-200 hover:scale-105 active:scale-95 shadow-lg';
  
  const variants = {
    primary:
      'bg-primary text-primary-foreground hover:opacity-90 border border-primary/25 shadow-md shadow-primary/10',
    secondary:
      'bg-secondary text-secondary-foreground hover:opacity-90 border border-secondary/25 shadow-md shadow-secondary/10',
    outline:
      'border-2 border-accent/45 text-foreground hover:bg-accent/10 hover:border-accent'
  };
  
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };

  return (
    <button
      className={cn(baseStyles, variants[variant], sizes[size], className)}
      {...props}
    >
      {children}
    </button>
  );
}
